<template>
  <div class="container">
    <div class="searchBox">
      <van-search
        v-model="keyword"
        shape="round"
        background="transparent"
        placeholder="搜索"
        @search="searchHandle"
      />
    </div>
    <div class="classifyNav">
      <van-tabs
        type="line"
        v-model="type"
        color="#d62f2f"
        title-active-color="#d62f2f"
        line-width="32px"
        line-height="5px"
        @change="typeClick"
      >
        <van-tab title="全部"></van-tab>
        <van-tab title="行业大咖"></van-tab>
        <van-tab title="品牌大咖"></van-tab>
      </van-tabs>
    </div>
    <div class="listBox">
      <van-list
        v-model="loading"
        :finished="finished"
        :error.sync="error"
        error-text="请求失败，点击重新加载"
        @load="getListHandle"
      >
        <div class="li_top" v-for="(item, index) in list" :key="index">
          <router-link
            class="avatarImg"
            :to="{ name: 'homePage', query: { mid: item.MemberId } }"
          >
            <van-image
              fit="cover"
              :src="item.Photo"
              round
              error-icon="https://cdn.alighting.com/cover/defaultPhoto.png"
            />
            <div class="headline">{{ item.NickName }}</div>
          </router-link>
          <div
            v-if="item.IsFollow"
            class="btn follwBtn"
            @click.stop="followHandle(item.MemberId, index)"
          >
            <span class="iconfont icon-gou"></span>
            <span>已关注</span>
          </div>
          <div
            v-else
            class="btn unfollwBtn"
            @click.stop="followHandle(item.MemberId, index)"
          >
            <span class="iconfont icon-add"></span>
            <span>关注</span>
          </div>
        </div>
      </van-list>
    </div>
  </div>
</template>
<script>
import { mobileMemberList } from "@/api/product";
import { Search, Tabs, Tab, Image, List } from "vant";
import { followMember, unFollowMember } from "@/api/index";
export default {
  name: "guruSearch",
  components: {
    "van-search": Search,
    "van-tabs": Tabs,
    "van-tab": Tab,
    "van-image": Image,
    "van-list": List,
  },
  data() {
    return {
      type: "",
      keyword: "",
      list: [],
      pageIndex: 1,
      total: 0,
      finished: false,
      error: false,
      loading: false,
    };
  },
  methods: {
    //搜索
    searchHandle() {
      if (this.trim(this.keyword)) {
        this.pageIndex = 1;
        this.list = [];
        this.getListHandle();
      }
    },

    //去除首尾的空格
    trim(s) {
      return s.replace(/(^\s*)|(\s*$)/g, "");
    },

    //动态列表关注操作
    followHandle(id, index) {
      var list = this.list;
      if (list[index].IsFollow) {
        unFollowMember({
          MemberId: id,
        }).then((res) => {
          list[index].IsFollow = false;
        });
      } else {
        followMember({
          MemberId: id,
        }).then((res) => {
          list[index].IsFollow = true;
        });
      }
      this.list = list;
    },

    //切换
    typeClick(name) {
      this.type = name;
      this.pageIndex = 1;
      this.list = [];
      this.loading = true;
      if (this.loading) {
        this.getListHandle();
      }
    },

    //获取会员列表
    getListHandle() {
      var that = this;
      var data = {
        KeyWord: that.keyword,
        Type: that.type,
        Page: {
          PageSize: 20,
          PageIndex: that.pageIndex,
        },
      };
      mobileMemberList(data)
        .then((res) => {
          if (that.pageIndex == 1) {
            that.list = [...res.Data.List];
          } else {
            that.list = [...that.list, ...res.Data.List];
          }
          that.total = res.Data.Total;
          that.pageIndex += 1;
          that.loading = false;
          if (that.list.length >= that.total) {
            that.finished = true;
          }
        })
        .catch((err) => {
          that.loading = false;
          that.error = true;
          that.Common.showMsg(err);
        });
    },
  },

  mounted() {
    this.keyword = this.$route.query.keyword;
  },
};
</script>
<style lang="less" scoped>
.container {
  .classifyNav {
    font-size: 14px;
    margin-bottom: 10px;
    background-color: #ffffff;
    border-radius: 0;
    /deep/.van-tab {
      flex: inherit !important;
      -webkit-flex: inherit !important;
      width: 80px !important;
      font-size: 14px !important;
    }
    /deep/.van-tab--active {
      font-weight: bold;
    }
    /deep/.van-hairline--top-bottom::after,
    .van-hairline-unset--top-bottom::after {
      border: none;
    }
  }
  .li_top {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    height: 60px;
    line-height: 60px;
    margin: 0px 10px;
    border-bottom: 1px solid #ddd;
    .headline {
      color: #4d5c87;
      font-size: 14px;
    }
    .avatarImg {
      position: relative;
      display: flex;
      align-items: center;
      .van-image {
        display: block;
        width: 40px;
        height: 40px;
        margin-right: 7px;
      }
    }
    .btn {
      width: 60px;
      height: 25px;
      line-height: 25px;
      border-radius: 13px;
      font-size: 11px;
      text-align: center;
      .iconfont {
        font-size: 12px;
        margin-right: 6px;
      }
    }
    .unfollwBtn {
      color: #fff;
      background: #d62f2f;
    }
    .follwBtn {
      color: #d62f2f;
      border: 1px solid #ccc;
    }
  }
}
</style>